import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedUiMaterialModule } from '@digital-platform/shared/ui-material';
import { AnalystsDropDownComponent } from './analysts-drop-down/analysts-drop-down.component';
import { CoordinatorsDropDownComponent } from './coordinators-drop-down/coordinators-drop-down.component';
import { SalesRepDropDownComponent } from './sales-rep-drop-down/sales-rep-drop-down.component';

@NgModule({
  imports: [CommonModule, SharedUiMaterialModule, ReactiveFormsModule],
  declarations: [
    SalesRepDropDownComponent,
    CoordinatorsDropDownComponent,
    AnalystsDropDownComponent
  ],
  exports: [
    SalesRepDropDownComponent,
    CoordinatorsDropDownComponent,
    AnalystsDropDownComponent
  ]
})
export class PeopleUiModule {}
